
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { API_SERVER } from '../../EnvConfig/env_config';
import { getCommonData } from '../Common/CommanServices';
import { BindAutoCompleteOnLoad, BindGrid, Number, exportToExcel, setFocus, setTitle } from '../Common/Common';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { post } from '../Common/service';
import Loader from '../Layout/Loader';

const ItemMaster = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false)
    const [ItemGroupOption, setItemgroupOption] = useState([]);
    const [EmptyItemOption, setEmptyItemOption] = useState([]);
    const [ActualItemOption, setActualItemOption] = useState([]);


    const [AddExtraItem, setAddExtraItem] = useState({
        Item: '',
        Quantity: 0
    });
    const [AddActualItem, setAddActualItem] = useState({
        Item: '',
        Quantity: 0
    });
    const [MenuText, setMenuText] = useState("Item Master");

    const [tableData, setTableData] = useState({
        totalRecord: 0,
        gridData: [{
        }]
    })
    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    })
    const [SaveData, setSaveData] = useState({
        ItemID: "0",
        ItemCode: "",
        ItemNo: "",
        ForeignName: "",
        ItemGroup: "",
        Empties: false,
        ContainActualItems: false,
        SalesItem: true,
        InventoryItem: true,
        Active: true,
        EmptiesItemDetails: [],
        ActualItemDetails: [],
    });

    const handleClear = async () => {
        setSaveData({
            ItemID: "0",
            ItemCode: "",
            ItemNo: "",
            ForeignName: "",
            ItemGroup: "",
            Empties: false,
            SalesItem: true,
            InventoryItem: true,
            Active: true,
            EmptiesItemDetails: [],
            ActualItemDetails: [],
        });

        setFilterData({
            ...filterData,
            SearchText: "",
            StartValue: "1",
            PageIndex: "1",
        });
        setAddExtraItem({
            Item: '',
            Quantity: 0
        })
        setAddActualItem({
            Item: '',
            Quantity: 0
        })
        setIsUpdate(!isUpdate)
    }
    useEffect(() => {
        setTitle('ItemMaster', setOpen);
        setFocus('txtItemCode')
        setTimeout(() => {
            setMenuText(document.title);
        }, 100)
    }, []);


    useEffect(() => {
        getItemData();
    }, [filterData.PageIndex, isUpdate]);

    useEffect(() => {
        if (!SaveData.Empties) {
            setSaveData({
                ...SaveData,
                EmptiesItemDetails: []
            })
        }
        setAddExtraItem({
            Item: '',
            Quantity: 0
        })
    }, [SaveData.Empties]);

    useEffect(() => {
        if (!SaveData.ContainActualItems) {
            setSaveData({
                ...SaveData,
                //ActualItemDetails: []
            })
        }
        setAddActualItem({
            Item: '',
            Quantity: 0
        })
    }, [SaveData.ContainActualItems]);

    const handleSubmit = () => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            ...SaveData, Token, LoginUserCode: loginCodeString
        }
        post(`${API_SERVER}/api/Master/InsertUpdateItemMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus)
                handleClear();
                getItemData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
            setIsLoading(false);
        })
    }
    const getItemData = (Type = 'S') => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...filterData, Type: Type, Token, LoginUserCode: loginCodeString
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Master/ShowExItemMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                const gridDataStr = res.gridData;
                const cleanedGridDataStr = gridDataStr.trim().replace(/\r\n/g, '');
                const gridDataJson = JSON.parse(cleanedGridDataStr);
                if (Type === 'S') {
                    setTableData({
                        ...tableData,
                        gridData: gridDataJson,
                        totalRecord: res.totalRecord
                    });
                }
                else {
                    exportToExcel(gridDataJson, 'ItemMaster');
                }
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.totalRecord <= 0) {
                setTableData(
                    {
                        totalRecord: 0,
                        gridData: [{
                        }]

                    })
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
            }
            setIsLoading(false)
        })
    }
    const handleEditData = (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token, LoginUserCode: loginCodeString, ItemID: ID
        }
        post(`${API_SERVER}/api/Master/EditItemMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                const editRecordStr = res.editRecord ? res.editRecord : "";
                const cleanededitRecordStr = editRecordStr.trim().replace(/\r\n/g, '');
                const editRecordJson = JSON.parse(cleanededitRecordStr);
                const EmptiesItemRecordStr = res.emptiesItemDetails;
                const ActualItemRecordStr = res.actualItemDetails;
                const cleanedEmptiesItemRecordStr = EmptiesItemRecordStr?.trim().replace(/\r\n/g, '');
                const cleanedActualItemRecordStr = ActualItemRecordStr?.trim().replace(/\r\n/g, '');
                const EmptiesItemRecordJson = JSON.parse(typeof (cleanedEmptiesItemRecordStr) === 'undefined' ? '[]' : cleanedEmptiesItemRecordStr);
                const ActualItemRecordJson = JSON.parse(typeof (cleanedActualItemRecordStr) === 'undefined' ? '[]' : cleanedActualItemRecordStr);
                //console.log(ActualItemRecordJson, "ActualItemRecordJsonActualItemRecordJsonActualItemRecordJson");
                setSaveData({
                    ...SaveData,
                    ItemID: ID,
                    ItemCode: editRecordJson[0]['ItemCode'],
                    ItemNo: editRecordJson[0]['ItemNo'],
                    ForeignName: editRecordJson[0]['ForeignName'],
                    ItemGroup: editRecordJson[0]['ItemGroup'],
                    Empties: (editRecordJson[0]['EmptiesItem'] === 'YES' ? true : false),
                    ContainActualItems: (editRecordJson[0]['ContainActualItems'] === 'YES' ? true : false),
                    SalesItem: (editRecordJson[0]['SalesItem'] === 'YES' ? true : false),
                    InventoryItem: (editRecordJson[0]['InventoryItem'] === 'YES' ? true : false),
                    Active: (editRecordJson[0]['Active'] === 'YES' ? true : false),
                    EmptiesItemDetails: EmptiesItemRecordJson,
                    ActualItemDetails: ActualItemRecordJson
                });
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)

            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
            setIsLoading(false);
        })
    }

    const handleDeleteData = (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token, LoginUserCode: loginCodeString, ItemID: ID
        }
        post(`${API_SERVER}/api/Master/DeleteItemMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                AlertBox(res.status, res.message, res.focus)

                getItemData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)

                setIsLoading(false);
            }
        })
    }
    const searchHandle = async () => {
        setFilterData({
            ...filterData,
            PageIndex: "1",
        })
        getItemData();
    }
    const handleDownloadExcel = async () => {
        getItemData('E');
    }

    const handleAddNewItem = () => {
        if (AddExtraItem.Item === "") {
            AlertBox("error", "Please Select Any Item !.", "");
            setFocus('txtItem');
        }
        else if (+AddExtraItem.Quantity <= 0) {
            AlertBox("error", "ItemQuantity should be greater than 0 !.", "");
            setFocus('txtQuantity');
        }
        else if (SaveData?.EmptiesItemDetails.length > 0 && SaveData?.EmptiesItemDetails.some(item => item.ItemCode === AddExtraItem.Item.split(':')[0].trim())) {
            AlertBox("error", "Item already exists in list !.", "");
            setFocus('txtItem');
        }

        else {
            const loginCodeString = String(LoginUserCode);
            setIsLoading(true);
            const data = {
                ...AddExtraItem, Token, LoginUserCode: loginCodeString
            }
            post(`${API_SERVER}/api/Master/ValidateItemForEmptyItemInItemMaster`, { ...data }, (res) => {
                if (res.status === 'SUCCESS') {
                    const newItem = [...SaveData.EmptiesItemDetails, {
                        ItemCode: AddExtraItem.Item.split(':')[0].trim(),
                        ItemNo: AddExtraItem.Item,
                        Quantity: AddExtraItem.Quantity,
                    }];
                    setSaveData({ ...SaveData, EmptiesItemDetails: newItem.filter(item => Object.keys(item).length !== 0) });
                    setAddExtraItem(
                        {
                            Item: "",
                            Quantity: 0,
                        })

                    setTimeout(() => {
                        setFocus('txtItem')
                    }, 500)

                }
                else if (res.message === "EXPIRED") {
                    navigate('/Login')
                }
                else if (res.message !== "") {
                    AlertBox(res.status, res.message, res.focus)
                }
                setIsLoading(false);
            })

        }
    }


    const handleRemoveExtraItemRow = (rowIndex) => {
        const updatedItemDetails = [...SaveData.EmptiesItemDetails];
        updatedItemDetails.splice(rowIndex, 1);
        setSaveData({
            ...SaveData,
            EmptiesItemDetails: updatedItemDetails,
        });

    };

    const handleAddActualItem = () => {
        if (AddActualItem.Item === "") {
            AlertBox("error", "Please Select Any Item !.", "");
            setFocus('txtItem');
        }
        else if (+AddActualItem.Quantity <= 0) {
            AlertBox("error", "ItemQuantity should be greater than 0 !.", "");
            setFocus('txtQuantity');
        }
        else if (SaveData?.ActualItemDetails.length > 0 && SaveData?.ActualItemDetails.some(item => item.ItemCode === AddActualItem.Item.split(':')[0].trim())) {
            AlertBox("error", "Item already exists in list !.", "");
            setFocus('txtItem');
        }
        else {
            const loginCodeString = String(LoginUserCode);
            setIsLoading(true);
            const data = {
                ...AddActualItem, Token, LoginUserCode: loginCodeString
            }
            //        post(`${API_SERVER}/api/Master/ValidateItemForEmptyItemInItemMaster`, { ...data }, (res) => {
            //           if (res.status === 'SUCCESS') {
            const newItem = [...SaveData.ActualItemDetails, {
                ItemCode: AddActualItem.Item.split(':')[0].trim(),
                ItemNo: AddActualItem.Item,
                Quantity: AddActualItem.Quantity,
            }];
            setSaveData({ ...SaveData, ActualItemDetails: newItem.filter(item => Object.keys(item).length !== 0) });
            setAddActualItem(
                {
                    Item: "",
                    Quantity: 0,
                })

            setTimeout(() => {
                setFocus('txtItem')
            }, 500)

            //        }
            //       else if (res.message === "EXPIRED") {
            //             navigate('/Login')
            //            }
            //           else if (res.message !== "") {
            //               AlertBox(res.status, res.message, res.focus)
            //           }
            setIsLoading(false);
            //   })

        }
    }


    const handleRemoveActualItemRow = (rowIndex) => {
        const updatedItemDetails = [...SaveData.ActualItemDetails];
        updatedItemDetails.splice(rowIndex, 1);
        setSaveData({
            ...SaveData,
            ActualItemDetails: updatedItemDetails,
        });

    };


    const getItem = () => {
        setItemgroupOption([]);
        let temp = {
            Type: "GetItemGroup",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let ItemData = res.autoCompleteData || [];
                setItemgroupOption(ItemData);
            } else {
                setItemgroupOption([]);
            }
        });
    };
    let ItemOptionArr = []
    for (let i = 0; i < ItemGroupOption.length; i++) {
        let mydata = ItemGroupOption[i]?.values
        ItemOptionArr.push(mydata)
    };

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Item Code<span className="Required">*</span></label>
                                            <input
                                                disabled={SaveData.ItemID !== "0" ? true : false}
                                                id='txtItemCode'
                                                type="text"
                                                maxLength="10"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtItemNo')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Item Code'
                                                value={SaveData.ItemCode}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, ItemCode: e.target.value.toLocaleUpperCase()
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Item No<span className="Required">*</span></label>
                                            <input
                                                id='txtItemNo'
                                                type="text"
                                                maxLength="500"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtForeignName')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Item No'
                                                value={SaveData.ItemNo}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, ItemNo: e.target.value.toLocaleUpperCase()
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Foreign Name</label>
                                            <input
                                                id='txtForeignName'
                                                type="text"
                                                maxLength="1000"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtItemGroup')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Foreign Name'
                                                value={SaveData.ForeignName}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, ForeignName: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">

                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("chkEmpties") };
                                                }}
                                                label='Item Group'
                                                placeholder="Enter Item Group"
                                                maxLength='50'
                                                options={ItemOptionArr}
                                                id='txtItemGroup'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getItem()}
                                                inputValue={SaveData.ItemGroup ? SaveData.ItemGroup : ''}
                                                onInputChange={(event, newInputValue) => setSaveData({
                                                    ...SaveData, ItemGroup: newInputValue
                                                })
                                                }
                                            />
                                        </div>
                                    </div>
                                    {(SaveData.ItemGroup !== '' && SaveData.ItemGroup.split(':')[0].trim() !== '106') ?
                                        <>
                                            <div className="col-lg-3 col-md-4 col-sm-6">
                                                <div className="form-check form-switch">
                                                    <label
                                                        className="form-check-label"
                                                    >
                                                      Contains Virtual Item / Empties
                                                    </label>
                                                    <input
                                                        id='chkEmpties'
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('containsActualItems')
                                                            };
                                                        }}
                                                        checked={SaveData.Empties}
                                                        onChange={(e) => {
                                                            const newValue = e.target.checked;
                                                            setSaveData({
                                                                ...SaveData,
                                                                Empties: newValue,
                                                                ContainActualItems: newValue,
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                           
                                        </>
                                        :
                                        <></>
                                    }
                                   
                                    <div className="col-lg-3 col-md-4 col-sm-6" style={{ display: "none" }}>
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"

                                            >
                                                Sales Item
                                            </label>
                                            <input
                                                id='chkSalesItem'
                                                className="form-check-input"
                                                type="checkbox"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('chkInventoryItem')
                                                    };
                                                }}
                                                checked={SaveData.SalesItem}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, SalesItem: e.target.checked
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6" style={{ display: "none" }}>
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"

                                            >
                                                Inventory Item
                                            </label>
                                            <input
                                                id='chkInventoryItem'
                                                className="form-check-input"
                                                type="checkbox"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('chkActive')
                                                    };
                                                }}
                                                checked={SaveData.InventoryItem}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, InventoryItem: e.target.checked
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"
                                                htmlFor="activeCheckbox"
                                            >
                                                Active
                                            </label>
                                            <input
                                                id='chkActive'
                                                className="form-check-input"
                                                type="checkbox"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('btnSave')
                                                    };
                                                }}
                                                checked={SaveData.Active}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Active: e.target.checked
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    {SaveData.Empties ?
                                        <>
                                            <div className='row'>
                                                <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                                                    <div style={{
                                                        color: '#0e2139', fontWeight: "bold",
                                                        fontSize: "18px",
                                                    }}>Contains Virtual Items</div>
                                                    <div className="recoard-bata service-content-area" style={{ padding: '0rem 0rem 0rem 0rem' }}>
                                                        <div className="table-responsive">
                                                            <table className="table-bordered" style={{ width: "100%" }} cellSpacing="0">
                                                                <thead className="sticky-top">
                                                                    <tr>
                                                                        <th>Item No<span className="Required">*</span></th>
                                                                        <th>Quantity<span className="Required">*</span></th>
                                                                        <th>Add Item</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>

                                                                    <tr>
                                                                        <td className='fields'>
                                                                            <Autocomplete
                                                                                id={`txtItem`}
                                                                                inputValue={AddExtraItem.Item}
                                                                                options={EmptyItemOption}
                                                                                disablePortal
                                                                                maxLength="100"
                                                                                freeSolo
                                                                                style={{ minWidth: '350px' }}
                                                                                autoComplete
                                                                                renderInput={(params) => <TextField {...params}
                                                                                    className="form-control"
                                                                                    maxLength='100'
                                                                                    placeholder='Enter Item No'
                                                                                />}
                                                                                onInputChange={(e, newInputValue) => {
                                                                                    setAddExtraItem({
                                                                                        ...AddExtraItem, Item: newInputValue
                                                                                    })
                                                                                }}
                                                                                onFocus={() => {
                                                                                    BindAutoCompleteOnLoad({ setOnState: setEmptyItemOption, Prefix: '', Type: 'GetEmptyItemGroupList', ContextKey: (SaveData.EmptiesItemDetails > 0 ? SaveData?.EmptiesItemDetails?.map(item => item.ItemCode).join(',') : ""), ContextKey2: SaveData?.ItemGroup || '' })
                                                                                }}

                                                                            />
                                                                        </td>
                                                                        <td className='fields'>
                                                                            <input className="form-control" type='text'
                                                                                id={`txtQuantity`}
                                                                                style={{ minWidth: '70px' }}
                                                                                maxLength="10"
                                                                                value={AddExtraItem.Quantity}
                                                                                onChange={(e) => {
                                                                                    setAddExtraItem({
                                                                                        ...AddExtraItem, Quantity: Number(e.target.value)
                                                                                    })
                                                                                }}

                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === 'Enter') {
                                                                                        setFocus('btnAddExtraItem');
                                                                                    };
                                                                                }}
                                                                            />
                                                                        </td>
                                                                        <td className='fields'>

                                                                            <button onClick={() => { handleAddNewItem() }}
                                                                                title="Add Item"
                                                                                className="btn btn-link text-success btn-sm"
                                                                                id='btnAddExtraItem'>
                                                                                <i className="bi bi-plus"></i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>

                                                            </table>

                                                        </div>

                                                    </div>
                                                </div>
                                                {SaveData?.EmptiesItemDetails.length > 0 ?
                                                    <>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                                                            <div style={{
                                                                color: '#0e2139', fontWeight: "bold",
                                                                fontSize: "18px",
                                                            }}>Virtual Items List</div>
                                                            <div className="recoard-bata service-content-area" style={{ padding: '0rem 0rem 0rem 0rem' }}>
                                                                <div className="table-responsive">
                                                                    <table className="table-bordered" style={{ width: "100%" }} cellSpacing="0">
                                                                        <thead className="sticky-top">
                                                                            <tr>
                                                                                <th>Delete Item</th>
                                                                                <th>Item No</th>
                                                                                <th>Quantity</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {SaveData?.EmptiesItemDetails?.map((row, rowIndex) => (
                                                                                <tr key={rowIndex}>
                                                                                    <td className='fields'>
                                                                                        <button title="Delete Item" className="btn btn-link text-danger btn-sm" onClick={() => { handleRemoveExtraItemRow(rowIndex) }}>
                                                                                            <i className="bi bi-trash"></i>
                                                                                        </button>
                                                                                    </td>
                                                                                    <td className='fields'>
                                                                                        {SaveData.EmptiesItemDetails[rowIndex].ItemNo}
                                                                                    </td>
                                                                                    <td className='fields'>
                                                                                        {SaveData.EmptiesItemDetails[rowIndex].Quantity}
                                                                                    </td>
                                                                                </tr>
                                                                            ))}

                                                                        </tbody>

                                                                    </table>

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </> : <></>
                                    }


                                    {SaveData.Empties ?
                                        <>
                                            <div className='row'>
                                                <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                                                    <div style={{
                                                        color: '#0e2139', fontWeight: "bold",
                                                        fontSize: "18px",
                                                    }}>Contains Empties Items</div>
                                                    <div className="recoard-bata service-content-area" style={{ padding: '0rem 0rem 0rem 0rem' }}>
                                                        <div className="table-responsive">
                                                            <table className="table-bordered" style={{ width: "100%" }} cellSpacing="0">
                                                                <thead className="sticky-top">
                                                                    <tr>
                                                                        <th>Item No<span className="Required">*</span></th>
                                                                        <th>Quantity<span className="Required">*</span></th>
                                                                        <th>Add Item</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>

                                                                    <tr>
                                                                        <td className='fields'>
                                                                            <Autocomplete
                                                                                id={`txtItem`}
                                                                                inputValue={AddActualItem.Item}
                                                                                options={ActualItemOption}
                                                                                disablePortal
                                                                                maxLength="100"
                                                                                freeSolo
                                                                                style={{ minWidth: '350px' }}
                                                                                autoComplete
                                                                                renderInput={(params) => <TextField {...params}
                                                                                    className="form-control"
                                                                                    maxLength='100'
                                                                                    placeholder='Enter Item No'
                                                                                />}
                                                                                onInputChange={(e, newInputValue) => {
                                                                                    setAddActualItem({
                                                                                        ...AddActualItem, Item: newInputValue
                                                                                    })
                                                                                }}
                                                                                onFocus={() => {
                                                                                    BindAutoCompleteOnLoad({ setOnState: setActualItemOption, Prefix: '', Type: 'GetActualItemGroupList', ContextKey: (SaveData.ActualItemDetails > 0 ? SaveData?.ActualItemDetails?.map(item => item.ItemCode).join(',') : ""), ContextKey2: SaveData?.ItemGroup || '' })
                                                                                }}

                                                                            />
                                                                        </td>
                                                                        <td className='fields'>
                                                                            <input className="form-control" type='text'
                                                                                id={`txtQuantity`}
                                                                                style={{ minWidth: '70px' }}
                                                                                maxLength="10"
                                                                                value={AddActualItem.Quantity}
                                                                                onChange={(e) => {
                                                                                    setAddActualItem({
                                                                                        ...AddActualItem, Quantity: Number(e.target.value)
                                                                                    })
                                                                                }}

                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === 'Enter') {
                                                                                        setFocus('btnAddActualItem');
                                                                                    };
                                                                                }}
                                                                            />
                                                                        </td>
                                                                        <td className='fields'>

                                                                            <button onClick={() => { handleAddActualItem() }}
                                                                                title="Add Item"
                                                                                className="btn btn-link text-success btn-sm"
                                                                                id='btnAddActualItem'>
                                                                                <i className="bi bi-plus"></i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>

                                                            </table>

                                                        </div>

                                                    </div>
                                                </div>
                                                {SaveData?.ActualItemDetails.length > 0 ?
                                                    <>
                                                        <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                                                            <div style={{
                                                                color: '#0e2139', fontWeight: "bold",
                                                                fontSize: "18px",
                                                            }}>Empties Items List</div>
                                                            <div className="recoard-bata service-content-area" style={{ padding: '0rem 0rem 0rem 0rem' }}>
                                                                <div className="table-responsive">
                                                                    <table className="table-bordered" style={{ width: "100%" }} cellSpacing="0">
                                                                        <thead className="sticky-top">
                                                                            <tr>
                                                                                <th>Delete Item</th>
                                                                                <th>Item No</th>
                                                                                <th>Quantity</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {SaveData?.ActualItemDetails?.map((row, rowIndex) => (
                                                                                <tr key={rowIndex}>
                                                                                    <td className='fields'>
                                                                                        <button title="Delete Item" className="btn btn-link text-danger btn-sm" onClick={() => { handleRemoveActualItemRow(rowIndex) }}>
                                                                                            <i className="bi bi-trash"></i>
                                                                                        </button>
                                                                                    </td>
                                                                                    <td className='fields'>
                                                                                        {SaveData.ActualItemDetails[rowIndex].ItemNo}
                                                                                    </td>
                                                                                    <td className='fields'>
                                                                                        {SaveData.ActualItemDetails[rowIndex].Quantity}
                                                                                    </td>
                                                                                </tr>
                                                                            ))}

                                                                        </tbody>

                                                                    </table>

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </> : <></>
                                    }



                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            {SaveData.ItemID !== '0' ? (isLoading ? <button className="button save-btn btn-disable" id='btnSave' disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindGrid
                tableData={tableData}
                setFilterData={setFilterData}
                filterData={filterData}
                searchHandle={searchHandle}
                handleEditData={handleEditData}
                handleDeleteData={handleDeleteData}
                FormName='ItemMaster' />

            {isLoading ?
                <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}

        </main>
    )
}
export default ItemMaster